// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Counts Component */
.ids-counts {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--ids-counts-color-text);
  contain: content;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  text-align: center;
}
.ids-counts::part(link) {
  width: 100%;
}
.ids-counts[href] {
  color: var(--ids-counts-links-color-text);
}
.ids-counts[color] {
  color: unset;
}

.ids-counts div[count-value] {
  font-size: var(--ids-counts-label-font-size);
}

.ids-counts div[count-text] {
  font-size: var(--ids-counts-value-font-size);
}

a:focus {
  border: 1px solid var(--ids-color-border-focus);
  box-shadow: var(--ids-shadow-30);
  outline: none;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-counts/ids-counts.scss","webpack://./src/themes/mixins/ids-core-mixins.scss"],"names":[],"mappings":"AAAA,yBAAA;AAGA;ECOE,mCAAA;EACA,kCAAA;EDLA,mCAAA;EACA,gBAAA;EACA,+EAAA;EACA,kBAAA;AADF;AAGE;EACE,WAAA;AADJ;AAIE;EACE,yCAAA;AAFJ;AAKE;EACE,YAAA;AAHJ;;AAOA;EACE,4CAAA;AAJF;;AAOA;EACE,4CAAA;AAJF;;AAOA;EACE,+CAAA;EACA,gCAAA;EACA,aAAA;AAJF","sourcesContent":["/* Ids Counts Component */\n@use '../../themes/mixins/ids-core-mixins' as core;\n\n.ids-counts {\n  @include core.antialiased();\n\n  color: var(--ids-counts-color-text);\n  contain: content;\n  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);\n  text-align: center;\n\n  &::part(link) {\n    width: 100%;\n  }\n\n  &[href] {\n    color: var(--ids-counts-links-color-text);\n  }\n\n  &[color] {\n    color: unset;\n  }\n}\n\n.ids-counts div[count-value] {\n  font-size: var(--ids-counts-label-font-size);\n}\n\n.ids-counts div[count-text] {\n  font-size: var(--ids-counts-value-font-size);\n}\n\na:focus {\n  border: 1px solid var(--ids-color-border-focus);\n  box-shadow: var(--ids-shadow-30);\n  outline: none;\n}\n","// Breakpoints - this cant be tokens\n$breakpoint-xxl: 1440px;\n$breakpoint-xl: 1280px;\n$breakpoint-lg: 1024px;\n$breakpoint-md: 840px;\n$breakpoint-sm: 600px;\n$breakpoint-xs: 320px;\n\n// Sets Text Antialiasing\n@mixin antialiased {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n// vendor prefixed transitions for regular attributes (non-vendor prefixed)\n@mixin transition($transitions-list...) {\n  @each $prefix in $prefixes {\n    #{$prefix}transition: $transitions-list;\n  }\n}\n\n// make the text invisible visually but readable by screen readers\n@mixin audible() {\n  clip: rect(0, 0, 0, 0);\n  height: 0;\n  line-height: 0;\n  min-height: 0;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
